import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/MMC/MAUDLIN_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLine } from './components/QuoteLine';
import { EstimatedQuantityOnHand } from './components/QuoteLine/EstimatedQuantityOnHand';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

export function MMCQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} />

        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation showFOB />
      </QuoteDetails>

      {quoteLines.map((line) => {
        return (
          <QuoteLine key={line.id} {...line} showDrawing>
            <PartId
              {...line.part}
              source={line.snapQuoteLineSource}
              showCustomerPartId
            />
            <PartDescription description={line.part.description} />
            {line.part.partSpecs && <PartSpecs specs={line.part.partSpecs} />}
            <PartSpecs specs={line.specs} />
            <EstimatedQuantityOnHand />
          </QuoteLine>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.bold, styles.textSmall, styles.paddedBottom]}>
            MTR’s provided at no cost with purchase order request and will be
            delivered with shipped goods. Requests after shipment for MTR’s -
            $10.00
          </Text>
          <Text style={[styles.bold, styles.textSmall, styles.paddedBottom]}>
            All custom generated items are non-refundable / non-returnable.
          </Text>
          <Text style={[styles.bold, styles.textSmall, styles.paddedBottom]}>
            Catalog item returns are subject to a 20% restocking fee.
          </Text>
          <Text style={[styles.bold, styles.textSmall, styles.paddedBottom]}>
            Orders less than $50.00 are subject to a $10.00 processing fee.
          </Text>
          <Text style={[styles.bold, styles.textSmall, styles.paddedBottom]}>
            Please contact us if delivery quoted does not meet your
            requirements.
          </Text>
          <Text style={[styles.bold, styles.textSmall, styles.paddedBottom]}>
            Typographical and clerical errors are subject to correction.
          </Text>

          <Text style={[styles.textSmall]}>
            View Your Order Status & Tracking Online:
          </Text>

          <Text style={[styles.textSmall, styles.paddedBottom]}>
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated with your order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the account email address will automatically
            populate.
          </Text>

          <Text style={[styles.bold, styles.textSmall]}>
            This quotation is made without benefit of reviewing any PO
            directions involving: dimensional or performance specifications, the
            quoted product. If such direction occurs with your submission of a
            PO, Maudlin Products reserves the right to increase process
            directions, shipping requirements, QC clauses, or any other
            requirement that may additionally impact the cost of producing the
            price of the quoted product to compensate for the added activity.
          </Text>
        </View>
      </View>
    </Page>
  );
}
